// extracted by mini-css-extract-plugin
module.exports = {"root":"InstructorsPage_root__bUFo7"};